import React from "react";
import { useFormikContext } from "formik";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import LinearProgress from "@mui/material/LinearProgress";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import ActivityLog from "../../../../views/asset/ActivityLog";
import useNotification from "../../../../hooks/notification";
import CaptureSkeleton from "../../../../components/CaptureSkeleton";
import { useKitsCollection } from "../../../../contexts/kitsCollection";
import FormFieldsKitting from "../../../../views/capture/FormFieldsKitting";
import KitBuilder from "../../../../components/TablePro/components/assets/KitBuilder";
import useRoles from "../../../../hooks/user/useRoles";
import useAuth from "../../../../hooks/useAuth";

export default function FormPageKitting({
  disabled,
  type,
  currentAsset,
  onCloseModal,
  projectId,
  isAssetLoading = false,
}) {
  const { user } = useAuth();
  const { settings } = user.company;
  const formProps = useFormikContext();
  const { notifyError } = useNotification();
  const isAdminOrManager = useRoles(["admin", "manager"]);

  const { loading, loadingMutation, updateAsset, createImage } = useKitsCollection();

  const handleSubmitAction = ({
    variables,
    setSubmitting,
    setStatus,
    setErrors,
    submitAction,
    handleSubmit,
  }) => {
    handleSubmit();
    setSubmitting(true);

    return submitAction({
      variables: { ...variables, input: variables.input },
      onSuccess: () => {
        setSubmitting(false);
        setStatus({ success: true });
      },
      onFailure: errors => {
        setStatus({ success: false });
        setErrors(errors);
        notifyError(errors);
        setSubmitting(false);
      },
    });
  };

  const submitUpdateAsset = ({ values, ...props }) => () => {
    const variables = { id: currentAsset?.id, input: values };

    return handleSubmitAction({ ...props, variables, submitAction: updateAsset });
  };

  return (
    <>
      <DialogContent sx={{ background: "#f4f6f8" }}>
        {(loading || isAssetLoading) && (
          <Box py={1}>
            <LinearProgress className="mt-2" />
          </Box>
        )}
        {currentAsset?.id ? (
          <FormFieldsKitting
            disabledForm={disabled}
            type={type}
            asset={currentAsset}
            loading={loadingMutation}
            updateAsset={updateAsset}
            createImage={createImage}
            setErrors={formProps.setErrors}
            errors={formProps.errors}
          />
        ) : (
          (loading || isAssetLoading) && <CaptureSkeleton />
        )}
        {currentAsset?.id && (
          <>
            <Box mb={2} />
            <KitBuilder
              disabled={disabled || !isAdminOrManager}
              entity={currentAsset}
              projectId={projectId}
            />
            <Box mb={2} />
            <Card>
              <CardContent>
                <ActivityLog
                  type="kit"
                  assetId={currentAsset.id}
                  defaultTab={settings.reservations ? "reserved_inventory" : "deplenish_inventory"}
                />
              </CardContent>
            </Card>
            <Box mb={2} />
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        {!disabled && currentAsset?.id && (
          <Box>
            <Button sx={{ mr: disabled ? 0 : 1.5 }} variant="outlined" onClick={onCloseModal}>
              Close
            </Button>
            <Button variant="contained" color="primary" onClick={submitUpdateAsset(formProps)}>
              Save
            </Button>
          </Box>
        )}
      </DialogActions>
    </>
  );
}
